import { createRouter, createWebHashHistory } from 'vue-router'
import Login from '../views/Login.vue'
import AdminLayout from '../layout/AdminLayout.vue'
import Overview from '../views/Overview.vue'
import Users from '../views/Users.vue'
import Roles from '../views/Roles.vue'
import Sessions from '../views/Sessions.vue'
import FollowUps from '../views/FollowUps.vue'
import KeywordRules from '../views/KeywordRules.vue'
import Complaints from '../views/Complaints.vue'
import { getToken } from '../utils/auth'

const routes = [
  { path: '/login', component: Login },
  {
    path: '/',
    component: AdminLayout,
    children: [
      { path: '', redirect: '/overview' },
      { path: '/overview', component: Overview },
      { path: '/users', component: Users },
      { path: '/roles', component: Roles },
      { path: '/sessions', component: Sessions },
      { path: '/follow-ups', component: FollowUps },
      { path: '/complaints', component: Complaints },
      { path: '/keyword-rules', component: KeywordRules }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.path === '/login') return next()
  if (!getToken()) return next('/login')
  next()
})

export default router
